module.exports = __webpack_public_path__ + "static/media/group48@2x.f640c0a0.jpg";